import { createAsyncThunk } from "@reduxjs/toolkit"
import {
  del,
  formDataPost,
  formDataPut,
  patch,
  post,
  put,
  get,
} from "helpers/api_helper"
import {
  ADD_MODIFIER,
  DELETE_MODIFIER,
  ENABLE_DISABLE_MODIFIER,
  GET_ALL_MODIFIER,
  GET_ALL_MODIFIER_LIST,
  GET_MODIFIER_DETAILS,
  GET_MODIFIER_GROUP_DETAILS,
  UPDATE_MODIFIER,
  UPDATE_MODIFIER_STATUS,
} from "helpers/url_helper"

export const getModifierDetails = createAsyncThunk(
  GET_MODIFIER_GROUP_DETAILS,
  async payload => {
    const response = await post(GET_MODIFIER_GROUP_DETAILS, payload)
    return response
  }
)

export const getAllModifier = createAsyncThunk(
  GET_ALL_MODIFIER,
  async payload => {
    const response = await post(GET_ALL_MODIFIER, payload)
    return response
  }
)

export const updateModifierStatus = createAsyncThunk(
  UPDATE_MODIFIER_STATUS,
  async payload => {
    const response = await patch(UPDATE_MODIFIER_STATUS, payload)
    return response
  }
)

export const deleteModifier = createAsyncThunk(
  DELETE_MODIFIER,
  async payload => {
    const response = await del(DELETE_MODIFIER, payload)
    return response
  }
)

export const addModifier = createAsyncThunk(ADD_MODIFIER, async payload => {
  const response = await formDataPost(ADD_MODIFIER, payload)
  return response
})

export const updateModifier = createAsyncThunk(
  UPDATE_MODIFIER,
  async payload => {
    const response = await formDataPut(UPDATE_MODIFIER, payload)
    return response
  }
)

export const getModifierDetail = createAsyncThunk(
  GET_MODIFIER_DETAILS,
  async payload => {
    const response = await post(GET_MODIFIER_DETAILS, payload)
    return response
  }
)

export const getModifierList = createAsyncThunk(
  GET_ALL_MODIFIER_LIST,
  async payload => {
    const response = await get(GET_ALL_MODIFIER_LIST, payload)
    return response
  }
)

export const enableDisableModifier = createAsyncThunk(
  ENABLE_DISABLE_MODIFIER,
  async payload => {
    const response = await patch(ENABLE_DISABLE_MODIFIER, payload)
    return response
  }
)
